<template>
    <div>
        <div style="width: 100%;overflow-x: hidden;">
            <div class="banner">
                <div class="textbox">
                    <div class="banner-text1">常见问题</div>
                    <div class="banner-text2">助力建设全国统一大市场，优化市场营商环境</div>
                </div>
            </div>
            <!-- 问题内容 -->

            <div class="box6">


                <el-collapse v-model="activeNames" @change="handleChange" class="problembox" accordion>


                    <el-collapse-item v-for="item in problemList" :title="item.questionTitle"
                        :name="item.questionSN" size="big">
                        <template #title>
                            <div style="display: flex;">
                                <span><img src="../assets/img/standard/ask-ico.png" alt="" class="askico"></span> <span
                                    class="asktitle">{{ item.questionTitle
                                    }}</span>
                            </div>

                        </template>
                        <div class="asktext">{{ item.answers[0].answerContent }}</div>

                    </el-collapse-item>

                </el-collapse>
                <!-- 分页 -->
                <div class="pagination">
                    <el-pagination v-model:current-page="newParms.current" v-model:page-size="newParms.size"
                        :page-sizes="[50, 100, 150, 200]" layout="prev, pager, next,sizes," :total="newParms.total"
                        background @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </div>
            </div>
            <div class="bottom" @click="tous">
                <div class="title">远程异地评标和评标专家库共享专栏</div>
                <div class="btn">联系我们</div>
            </div>
            <div class="bottombox2">
             
            </div>



        </div>
    </div>
</template>

<script lang='ts' setup>
import { reactive, toRefs, ref, onMounted } from 'vue'

import {  getproblemList, } from '../utils/axios/index.js'
import { ro } from 'element-plus/es/locale/index.js';
import { useRoute } from 'vue-router'
const route = useRoute()
import { useRouter } from "vue-router";
const router = useRouter();
//查询参数
let Listparms = ref({
    current: 1,
    size: 100,
    // problemType: '',
})
//跳转联系我们
const tous = () => {
    router.push('/contactUs')
}

onMounted(() => {

    //获取问题列表
    MgetproblemList()






})


let problemList = ref([])

//获取问题列表

const MgetproblemList = () => {
    getproblemList(Listparms.value).then(res => {
        problemList.value = res.data.records
    }).catch(res => {

    })
}

//分页size改变
const handleSizeChange = (val) => {
    Listparms.value.size = val
    getproblemList(Listparms.value).then(res => {
        problemList.value = res.data.records
        Listparms.value.total = res.data.total
    }).catch(err => {
    })
}
//分页页数改变

const handleCurrentChange = (val) => {
    Listparms.value.current = val
    getproblemList(Listparms.value).then(res => {
        problemList.value = res.data.records
        Listparms.value.total = res.data.total
    }).catch(err => {
    })
}







let newParms = ref({
    current: 1,
    size: 50,
    total: 0,
})





</script>
<style lang="scss" scoped>
.banner {
    width: 100%;
    height: 472px;
    position: relative;
    background: url('../assets/img/banner/problem.png') no-repeat center center;
    // background-size: cover;
    background-size: 100%;
    // margin-top: 64px;


    .textbox {
        width: 1200px;
        height: 120px;
        position: absolute;
        top: 190px;
        left: 50%;
        transform: translate(-50%);
    }

    .banner-text1 {
        color: var(--Color-Neutral-neutral-11, #323335);
        
        font-size: 36px;
        font-style: normal;
        font-weight: 600;
        line-height: 70px;
        text-align: left
    }

    .banner-text2 {
        color: var(--Color-Neutral-neutral-10, #64666B);
        text-align: center;
        
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
        text-align: left
    }


}

.news-content {
    width: 80%;
    min-width: 1200px;
    height: 100%;
    display: flex;
    margin: 0 auto;



}




.bottom {
    width: 100%;
    height: 80px;
    background: url('../assets/img/asked/towe.png') no-repeat center center;
    background-size: cover;
    border-radius: var(--Radius-Border-radius-4, 8px);
    margin: 0 auto;
    margin-top: 80px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;




    .title {
        color: #FFF;
        
        font-size: 28px;
        font-style: normal;
        font-weight: 600;
        line-height: 42px;
    }

    .btn {
        width: 240px;
        height: 42px;
        border-radius: 92px;
        background: #FFF;
        color: #0068FF;
        
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 42px;
        text-align: center;
        margin-left: 40px;
    }

}

.pagination {
    width: 80%;
    height: 80px;
    margin-left: 10%;
    margin-top: 80px;
    display: flex;
    justify-content: center
}

:deep(.el-pagination.is-background .el-pager li.is-active) {
    background-color: #3461FF !important;
}



:deep(.el-pagination.is-background .el-pager li.is-active) {
    background-color: #3461FF !important;
    border: none !important;
}

// // .el-pager li.is-active

// :deep(.el-select__wrapper){
//     border: 1px solid #3461FF !important;
//     box-shadow:none; 
// }

:deep(.el-select__wrapper.is-focused) {
    box-shadow: 0 0 0 1px #3461FF inset;
    border: 1px solid #3461FF !important;
}

:deep(.el-select__wrapper.is-hovering) {
    //  box-shadow:none; 
    box-shadow: 0 0 0 1px #3461FF inset;
    border: 1px solid #3461FF !important;
}

:deep(.pagination.el-select-dropdown__item.is-selected) {
    color: #3461FF !important;
}






.line1 {
    border-bottom: 1px solid var(--Color-Auxiliary-auxiliary-2, #D7D7DC);
    width: 90%;
    margin: 0 auto;
    margin-top: 9px;
}

:deep(.el-pager li) {
    border: 1px solid rgb(230, 223, 230);
    margin: 0 5px;
}

:deep(.el-pager li.is-active) {
    border: 1px solid #409eff;
    font-weight: normal !important;
}

.box6 {
    width: 1200px;
    margin: 0 auto;
    min-width: 1200px;
    margin-top: 50px;



}



.navbox {
    flex-grow: 1;
    margin-left: 50px;
    display: flex;
    margin-top: 50px;
}



.nav {
    white-space: nowrap;
    padding: 0 20px 0 20px;
    text-align: center;
    color: #4E5969;
    
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    /* 120% */


}

.navText {
    position: relative;
}

.nav:hover {
    cursor: pointer;
    /* 鼠标移入时变为小手 */
    color: #1664FF;
    /* 文字变为蓝色 */
}

.nav.active {
    color: #1664FF;
    /* 文字变为蓝色 */
}

.indicator {
    width: 100%;
    height: 2px;
    border: 1px solid #1664FF;
    background-color: #1664FF;
    position: absolute;
    bottom: -10px;
}

.nav.active .indicator {
    opacity: 1;
    /* 选中时指示器不透明度为1 */
}

:deep(.el-collapse-item__header) {
    color: #191919;
    
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    /* 150% */
}

:deep(.btn-prev .el-icon) {
    font-size: 20Px !important;
    line-height: 32px;
}

:deep(.btn-next .el-icon) {
    font-size: 20Px !important;
    line-height: 32px;
}

.bottombox2 {
    width: 100%;
    height: 88px;
}

.askico {
    width: 24px;
    height: 21px
}

.asktitle {
    color: #191919;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    margin-left: 10px;
}

.problembox {
    width: 1200px;
    margin: 0 auto;
}
</style>